import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function AddSubmissionsChatService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/addSubmissionsChats`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        // notify.NotifySuccess("Asset note added successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while adding asset note, please try again later.");
        return false;
    });
}

export default AddSubmissionsChatService;